import { useQuery } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import { IPaginatedResponse, ISubscriptionHistoryItem } from "../../interfaces";

export const useSubscriptionHistory = (params?: Record<string, string>) => {
  return useQuery<IPaginatedResponse<ISubscriptionHistoryItem>, Error>({
    queryKey: ["stripe", "history", params],
    queryFn: async () => {
      const query = params ? `?${new URLSearchParams(params).toString()}` : "";
      const response = await httpService.get<IPaginatedResponse<ISubscriptionHistoryItem>>(
        `${API_CONFIG.path.stripeHistory}${query}`
      );
      return response;
    },
  });
};
